import { getCountry, getLanguageFromIsoLocale } from "@/lib/locale/locale-common-utils"
import { cn } from "@/lib/utils"

interface StoryblokSwissLocaleSwitchProps {
  isoLocale: string
  variant?: "default" | "rebrush"
}

function getHrefLangLinkForCurrentOrigin(switchToLocale: string): string | undefined {
  const href = document.querySelector(`link[hreflang="${switchToLocale}"]`)?.getAttribute("href")
  if (!href) {
    return undefined
  }

  if (location.hostname === "localhost" || location.hostname.includes("test-local.")) {
    const hrefUrl = new URL(href, location.origin)
    return location.origin + hrefUrl.pathname + hrefUrl.search + hrefUrl.hash
  }

  return href
}

function determineSwitchToLocaleHref(country: string, switchToLocale: string | undefined) {
  const targetLanguage = getLanguageFromIsoLocale(switchToLocale ?? "de-DE")
  let prefix = "/"
  const currentPathWithQueryAndHash = location.href.replace(location.origin, "")
  let resultHref = currentPathWithQueryAndHash

  //console.log(targetLanguage)
  //console.log(switchToLocale)

  console.log("Switch to locale with country: " + country + " and target language: " + targetLanguage)
  if (country ?? "".toLowerCase() === "ch") {
    if ((targetLanguage ?? "".toLowerCase()) === "fr") {
      //  console.log("Target FR -> Add prefix")
      //  console.log(currentPathWithQueryAndHash)

      prefix = "/fr/CHF"
      resultHref = prefix + currentPathWithQueryAndHash
    } else if ((targetLanguage ?? "".toLowerCase()) === "de") {
      //console.log("Target DE -> remove prefix")
      //console.log(currentPathWithQueryAndHash)
      if (currentPathWithQueryAndHash.startsWith("/fr/CHF")) {
        //console.log("Starts with prefix -> removing")
        resultHref = currentPathWithQueryAndHash.replace("/fr/CHF", "")
      }
    }
    //console.log(resultHref)
  }
  return resultHref
}

export default function StoryblokSwissLocaleSwitch({
  isoLocale,
  variant = "default",
}: StoryblokSwissLocaleSwitchProps) {
  let switchToLocale: string | undefined = undefined
  const country = getCountry(isoLocale)
  if (country === "ch") {
    switchToLocale = getLanguageFromIsoLocale(isoLocale) === "de" ? "fr-ch" : "de-ch"
  }

  return (
    <>
      {switchToLocale && (
        <div className={cn("flex justify-end", variant === "default" && "lg:ml-8")}>
          <button
            className={cn(
              "flex items-center justify-between gap-1",
              variant === "rebrush" &&
                "h-10 rounded-[4px] px-1.5 text-sm leading-4 font-semibold text-[#303030] hover:bg-[#F8F8F8] focus-visible:ring-2 focus-visible:ring-ub-hlblue focus-visible:outline-hidden"
            )}
            onClick={() => {
              location.href =
                getHrefLangLinkForCurrentOrigin(switchToLocale) ?? determineSwitchToLocaleHref(country, switchToLocale)
            }}
          >
            <div className="relative aspect-square h-5 rounded-sm bg-red-600">
              <span className="absolute inset-x-[40%] inset-y-[10%] bg-white"></span>
              <span className="absolute inset-x-[10%] inset-y-[40%] bg-white"></span>
            </div>
            <span className={"max-lg:hidden"}>{getLanguageFromIsoLocale(switchToLocale).toUpperCase()}</span>
          </button>
        </div>
      )}
    </>
  )
}
